<template>
    <v-card :class="{['bg-inner']: true, alerta}" :elevation="$$_elevacao">
      <v-card-title>
        {{detalhe.foqnome}} <b v-if="detalhe.foqobrigatorio === 'S'" class="obrigatorio">*</b>
      </v-card-title>
      <v-card-subtitle>
        {{detalhe.foqdescricao}}
      </v-card-subtitle>

      <v-card-text>

        <div v-if="temArquivo" class="tem-arquivo">
          <v-chip
            class="selection-file text-truncate"
            label
            color="primary"
            link
            :href="linkArquivo"
            target="_blank"
            >
              {{$$_FormataNomeArquivo(value)}}
          </v-chip>
          <v-icon class="ml-5" @click="$_removeArquivo">mdi-close</v-icon>
        </div>
        <v-file-input v-else v-model="value" ref="rules" :rules="rules"
         chips show-size
         prepend-icon=""
         truncate-length="15"
         class="file"
         flat solo >
          <template v-slot:prepend-inner>
            <v-icon class="icon-file">mdi-upload</v-icon>
          </template>
          <template v-slot:selection="{ file, text }">
            <v-chip class="selection-file"
              label
              :color="$$_rulesColor(file)">
              {{ text }}
            </v-chip>
          </template>
        </v-file-input>

      <template v-if="(detalhe?.subquestoes?.length > 0) && !complemento">
        <template v-for="(subitem, index) in detalhe.subquestoes">
          <div :key="subitem.id">
            <v-divider ></v-divider>
            <component
            :is="subitem.foqtipo"
            :key="subitem.id"
            :ref="`subquestao-${index + 1}`"
            :detalhe="subitem"
            :complemento="true"
            >
            </component>
          </div>
        </template>
      </template>
      </v-card-text>

    </v-card>

</template>

<script>
import errorHandler from '@/utils/error-handler';
import api from '@/services/api-recebimentoweb';

export default {
  name: 'CardFile',

  data() {
    return {
      value: null,
      alerta: false,
      temArquivo: false,
      linkArquivo: '',
      mimeMap: {
        pdf: [
          'application/pdf',
        ],
        txt: [
          'text/plain',
        ],
        doc: [
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
          'application/vnd.oasis.opendocument.text',
          'text/xml',
        ],
        xls: [
          'application/vnd.ms-excel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          'application/vnd.oasis.opendocument.spreadsheet',
        ],
        imagem: [
          'image/jpeg',
          'image/jpg',
          'image/png',
          'image/gif',
          'image/bmp',
          'image/webp',
        ],
        video: [
          'video/mp4',
          'video/webm',
          'video/ogg',
          'video/quicktime',
        ],
      },
      rules: [
        (value) => !value || value.size < 10000000 || 'O arquivo não pode ser maior que 10 MB!',
        (value) => {
          const tiposPermitidos = Object.keys(this.mimeMap);
          return (!value || tiposPermitidos.some((tipo) => this.mimeMap[tipo]?.includes(value?.type)))
          || 'Tipo de arquivo não permitido';
        },
      ],
    };
  },

  computed: {
    $$_elevacao() {
      return (this.$props.complemento) ? 5 : 0;
    },
  },

  methods: {
    $_alerta() {
      this.alerta = true;
      errorHandler(`${this.$props.detalhe.foqnome} é obrigatória!`);
    },
    $$_rulesColor(file) {
      console.log(file.type);
      const tiposPermitidos = Object.keys(this.mimeMap);
      const tipo = tiposPermitidos.some((mime) => this.mimeMap[mime]?.includes(file?.type));
      const tamanho = file.size > 10000000;
      return (!tipo || tamanho) ? 'red' : 'primary';
    },
    $$_FormataNomeArquivo(nome) {
      if (nome.length > 25) {
        return `${nome.substring(0, 12)}...${nome.substring(nome.length - 12, nome.length)}`;
      }
      return nome;
    },
    $_removeArquivo() {
      this.value = null;
      this.temArquivo = false;
    },
  },

  props: {
    detalhe: Object,
    complemento: {
      type: Boolean,
      default: false,
    },
  },

  mounted() {
    if (this.detalhe?.resposta.length > 0) {
      this.temArquivo = true;
      const [res] = this.detalhe.resposta;
      this.value = res?.forresposta;
      this.linkArquivo = `${api.defaults.baseURL}/formulario/uploads/respostas/${this.detalhe.foqidformularionuvem}/${this.detalhe.id}/${res.forresposta}`;
    }
  },
  watch: {
    value(valor) {
      if (valor) {
        this.alerta = false;
      }
    },
  },
};
</script>
/<style scoped>
  .bg-inner {
    width: 100%;
    background-color: #ffffff;
    border-radius: 15px;
    margin-top: 25px;
  }

  .obrigatorio {
    color: red;
    padding-left: 5px;
  }

    .alerta {
    border: 1px solid red;
    animation: vibracao 0.5s;
  }

  @keyframes vibracao {
    0% {
      transform: translateX(10px);
    }

    25% {
      transform: translateX(-10px);
    }

    50% {
      transform: translateX(10px);
    }

    75% {
      transform: translateX(-10px);
    }

    100% {
      transform: translateX(0px);
    }
  }

.file {
  border: solid 0.15em rgb(197, 196, 196) !important;
  border-radius: 10px;
  margin-bottom: 10px;
}

.file >>> .v-input__control {
  max-height: 3em !important;
  display: inline !important;
}

.icon-file{
  font-size: 2em !important;
  align-items: center;
}

.selection-file{
  align-items: center;
}
.tem-arquivo {
  border: solid 0.15em rgb(197, 196, 196) !important;
  border-radius: 10px;
  padding: 10px;
  width: fit-content;
}
</style>
